import { Injectable } from "@angular/core";
import { FormBuilder, FormGroup, FormControl, Validators } from "@angular/forms";
import { HexaValidator } from "../validators/hexa";
import { LocationValidator } from "../validators/location";
import { JsonValidator } from "../validators/json";

@Injectable()
export class GenFormBuilder {

  constructor(
    private formBuilder: FormBuilder
  ) { }

  genInputLang(control: string, form: FormGroup, langDefault: string = null) {
    form.addControl(
      control,
      this.formBuilder.group({
        en: new FormControl(
          "",
          langDefault === "en" ? Validators.required : Validators.nullValidator
        ),
        es: new FormControl(
          "",
          langDefault === "es" ? Validators.required : Validators.nullValidator
        )
      })
    );
  }

  genGroupToggle(control: string, form: FormGroup, modules: any) {
    let newModules = {};
    modules.forEach(module => {
      newModules[module] = new FormControl(false);
    });

    form.addControl(
      control,
      this.formBuilder.group(newModules)
    );
  }

  genInputString(
    control: string,
    form: FormGroup,
    isRequired: boolean = false,
    defaultValue: string = null,
    minLength: number = 0
  ) {
    form.addControl(
      control,
      new FormControl(
        defaultValue ? defaultValue : "", Validators.compose([isRequired ? Validators.required : Validators.nullValidator, Validators.minLength(minLength)])
      )
    );
  }

  genInputJSON(
    control: string,
    form: FormGroup,
    isRequired: boolean = false,
    defaultValue: any = {}
  ) {
    form.addControl(
      control,
      new FormControl(
        defaultValue,
        isRequired ? JsonValidator.isJsonRequired : Validators.nullValidator
      )
    );
  }

  genInputJSONLength(
    control: string,
    form: FormGroup,
    isRequired: boolean = false,
    defaultValue: any = {}
  ) {
    form.addControl(
      control,
      new FormControl(
        defaultValue,
        isRequired ? JsonValidator.isJsonFiveLength : Validators.nullValidator
      )
    );
  }

  genInputEmail(
    control: string,
    form: FormGroup,
    isRequired: boolean = false,
    defaultValue: string = null
  ) {
    form.addControl(
      control,
      new FormControl(
        defaultValue ? defaultValue : "",
        Validators.compose([
          Validators.email,
          isRequired ? Validators.required : Validators.nullValidator
        ])
      )
    );
  }

  genInputLatitude(
    control: string,
    form: FormGroup,
    isRequired: boolean = false,
    defaultValue: string = null
  ) {
    form.addControl(
      control,
      new FormControl(
        defaultValue,
        Validators.compose([
          LocationValidator.latitude,
          isRequired ? Validators.required : Validators.nullValidator
        ])
      )
    );
  }

  genInputLongitude(
    control: string,
    form: FormGroup,
    isRequired: boolean = false,
    defaultValue: string = null
  ) {
    form.addControl(
      control,
      new FormControl(
        defaultValue ? defaultValue : "",
        Validators.compose([
          LocationValidator.longitude,
          isRequired ? Validators.required : Validators.nullValidator
        ])
      )
    );
  }

  genInputHexa(control: string, form: FormGroup, isRequired: boolean = false) {
    form.addControl(
      control,
      new FormControl(
        "",
        Validators.compose([
          HexaValidator.isHexa,
          isRequired ? Validators.required : null
        ])
      )
    );
  }

  genToggle(control: string, form: FormGroup, isRequired: boolean = false) {
    form.addControl(
      control,
      new FormControl(
        false,
        isRequired ? Validators.required : Validators.nullValidator
      )
    );
  }

  genInputNumber(
    control: string,
    form: FormGroup,
    isRequired: boolean = false,
    defaultValue: number = null
  ) {
    // TODO: Poner validador de number
    form.addControl(
      control,
      new FormControl(
        (defaultValue !== null) ? defaultValue : '',
        isRequired ? Validators.required : Validators.nullValidator
      )
    );
  }

  genInputDate(control: string, form: FormGroup, isRequired: boolean = false) {
    // TODO: Poner validador de fechas
    form.addControl(
      control,
      new FormControl(
        "",
        Validators.compose([
          isRequired ? Validators.required : Validators.nullValidator
        ])
      )
    );
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/form.ts